import type { PaintingRecord } from "../types";

const IMAGE_EXTS = [".png", ".webp", ".jpeg", ".jpg"];

function pushUrl(seen: Set<string>, out: string[], u: string | undefined): void {
  const t = (u || "").trim();
  if (!t || t.startsWith("http://") || t.startsWith("https://")) return;
  const path = t.startsWith("/") ? t : `/${t}`;
  if (!seen.has(path)) {
    seen.add(path);
    out.push(path);
  }
}

/** 列表卡片：优先画廊图（按 id 一一对应，最可靠） */
export function paintingCardImageCandidates(p: PaintingRecord): string[] {
  const id = p.id;
  const seen = new Set<string>();
  const out: string[] = [];

  pushUrl(seen, out, `/gallery/painting_${id}.jpg`);
  if (p.imageUrl?.trim() && !p.imageUrl.startsWith("http")) {
    pushUrl(seen, out, p.imageUrl);
  }
  for (const ext of IMAGE_EXTS) {
    pushUrl(seen, out, `/images/painting_${id}${ext}`);
  }
  return out;
}

/** 详情页：同样优先 gallery，避免 /images 下错链或重复 png */
export function paintingDetailImageCandidates(p: PaintingRecord): string[] {
  const id = p.id;
  const seen = new Set<string>();
  const out: string[] = [];

  pushUrl(seen, out, `/gallery/painting_${id}.jpg`);
  if (p.imageUrl?.trim() && !p.imageUrl.startsWith("http")) {
    pushUrl(seen, out, p.imageUrl);
  }
  pushUrl(seen, out, `/images/painting_${id}.png`);
  pushUrl(seen, out, `/images/painting_${id}.webp`);
  pushUrl(seen, out, `/images/painting_${id}.jpeg`);
  pushUrl(seen, out, `/images/painting_${id}.jpg`);
  return out;
}

export function wirePaintingImgFallbacks(scope: HTMLElement): void {
  scope.querySelectorAll<HTMLImageElement>("img.art-img-with-fallback").forEach((img) => {
    const enc = img.dataset.pfb;
    if (!enc) return;
    let urls: string[];
    try {
      urls = JSON.parse(decodeURIComponent(enc)) as string[];
    } catch {
      return;
    }
    if (!Array.isArray(urls) || urls.length === 0) return;

    let idx = 0;

    const showMissing = () => {
      const alt = img.alt || "画作";
      const ph = document.createElement("div");
      ph.className = "art-img-missing";
      ph.setAttribute("role", "img");
      ph.setAttribute("aria-label", `${alt}（暂无可用本地图片）`);
      ph.innerHTML = `<span>暂无图片</span>`;
      img.replaceWith(ph);
    };

    const onErr = () => {
      idx += 1;
      if (idx < urls.length) {
        const next = urls[idx];
        if (next) {
          img.src = next;
          return;
        }
      }
      img.removeEventListener("error", onErr);
      showMissing();
    };

    img.addEventListener("error", onErr);

    const onLoad = () => {
      const wrap = img.closest(
        ".art-card-image-wrap, .art-detail-visual-frame, .pair-card-visual"
      );
      if (!wrap || !img.naturalWidth || !img.naturalHeight) return;
      const ratio = img.naturalWidth / img.naturalHeight;
      if (ratio >= 1.15) wrap.classList.add("is-landscape");
      else if (ratio <= 0.85) wrap.classList.add("is-portrait");
      else wrap.classList.add("is-squareish");
    };
    if (img.complete && img.naturalWidth) onLoad();
    else img.addEventListener("load", onLoad, { once: true });
  });
}
